import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from '../shared/layouts/app/AppLayout';
import LoadingScreen from '../shared/ui/loading/LoadingScreen';
import { ROUTES } from "../core/config";

// Autres pages futures
// const SupportPage = lazy(() => import('../features/public/pages/SupportPage'));

const PublicRoutes = () => {
  return (
    <AppLayout>
      <Suspense fallback={<LoadingScreen text="Chargement Hubvex" />}>
        <Routes>
          <Route
            path="/"
            element={
              <Navigate
                to={ROUTES.APP_ROUTES.DASHBOARD}
                replace
              />
            }
          />
        </Routes>
      </Suspense>
    </AppLayout>
  );
};

export default PublicRoutes;